export default [
  {
    url: "/dashboard",
    name: "Dashboard",
    icon: "assignment",
  },
  {
    url: "/users",
    name: "Manage Users",
    icon: "account_box",
  },
  {
    url: "/site-settings",
    name: "Site Settings",
    icon: "settings",
  },
  {
    url: "/admin-users",
    name: "Admin Accounts",
    icon: "shield",
  },
  {
    url: "/upload-industry",
    name: "Upload Industry data",
    icon: "description",
  },
];
